export const FETCH_CATALOG_REQUEST = 'catalog/FETCH_REQUEST';
export const FETCH_CATALOG_SUCCESS = 'catalog/FETCH_SUCCESS';
export const FETCH_CATALOG_FAILURE = 'catalog/FETCH_FAILURE';
